<template>
  <transition
    enter-active-class="animate__animated animate__fadeIn animate__faster"
    leave-active-class="animate__animated animate__fadeOut animate__faster"
  >
    <!-- Edit Pop-Up -->
    <div class="overlay">
      <div
        class="popUp form row d-flex justify-content-center"
        style="width: 30%"
      >
        <em
          @click.prevent="
            $parent.shwChangeDmnName = !$parent.shwChangeDmnName;
            $parent.warningPopUp = false;
          "
          class="bi-x-lg position-absolute d-flex justify-content-end"
          style="right: 7px"
        ></em>
        <div class="col-md-12 overflow-hidden">
          <!-- Url -->
          <div class="col-md-12 text-left mb-4">
            <label for="url" class="col-sm-6 col-form-label"
              >New domain name</label
            >
            <input
              type="text"
              class="form-control"
              id="url"
              v-cloak
              placeholder="URL"
              :class="{ errorInput: fireError }"
              v-model="url"
            />
          </div>
          <div class="btn-group d-flex justify-content-center">
            <button type="button" class="btn btn-success mr-2" @click="change">
              Change
            </button>
            <button
              type="button"
              class="btn btn-light"
              @click="$parent.shwChangeDmnName = !$parent.shwChangeDmnName"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
      <!-- Error Pop-Up -->
      <Error v-if="error" :error="error" />
    </div>
  </transition>
</template>

<script>
import { mapActions } from "vuex";
import Domains from "../../../apis/Domains";
import Error from "../../popUps/Error.vue";

export default {
  name: "ChangeDmnName",
  components: {
    Error,
  },
  props: ["url", "dmn_id"],
  data() {
    return {
      //url: "",
      fireError: false,
      error: "",
    };
  },
  methods: {
    ...mapActions(["show"]),
    change() {
      if (this.url) {
        Domains.update(this.dmn_id, {
          url: this.url,
          fcm_conf: "client",
        })
          .then(() => {
            this.show();
            this.$parent.shwChangeDmnName = false;
          })
          .catch((err) => {
            this.error = err.response.message;
          });
      } else {
        this.fireError = true;
      }
    },
  },
};
</script>
  

<style>
input[type="checkbox"] {
  height: 12px;
  width: 12px;
  margin: 6px;
}
button.v-icon {
  color: #c6c6c6 !important;
}
.lgImage {
  width: 100%;
  height: 200px;
  background-size: cover;
  background-position: center;
}
